























































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import iwModal from "@/shared/components/Modal.vue";
import { Picture } from "@/shared/interfaces/Picture.interface";
import { deleteOrderPublishPictures } from "@/shared/scripts/UploadPicture";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwModal: iwModal
    },

    data: function() {
        return {
            isMobile: true as boolean,
            internalPicture: null as Picture|null
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),
        picture: function() : Picture|null {
            return this.$store.getters["ModalModule/getActivePicture"];
        },
        isPictureModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isPictureModalOpen"];
        },
        modalTitle: function(): string {
            return this.$t("edit_picture") as string;
        },
        isMainPictureButtonShown: function() : boolean {
            const pictures = this.$store.getters["PicturesModule/getPictures"];
            const { picture } = this;
            if (!picture || pictures.length === 0) return false;
            if (pictures[0] === picture) return false;
            return pictures.includes(picture);
        }
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods: {
        ...mapActions({
            removePicture: "PicturesModule/removePicture"
        }),
        closePictureModal: function() {
            this.$store.commit("ModalModule/closePictureModal");
        },
        openPictureModal: function() {
            this.$store.commit("ModalModule/openPictureModal");
        },
        deletePicture: function() {
            //Local state update
            this.removePicture(this.picture);

            try {
                deleteOrderPublishPictures(true);
                this.$store.commit("ModalModule/closePictureModal");
            } catch (e) {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
            }

            this.$store.commit("ModalModule/closePictureModal");
        },
        setAsMainPicture: function() {
            this.$store.commit("PicturesModule/setAsMainPicture", this.picture);

            deleteOrderPublishPictures(true).catch(() => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
            });
        }
    }
});

